// Affirmations - written by Sneha
export const AFFIRMATIONS = [
  "you are the most beautiful human being",
  "you are a fierce diva",
  "i'm truly so inspired by you?? like frfr",
  "you are incredible at what you do",
  "sneha is lucky she knows you :)",
  "sneha wants you to know you are loved so much",
  "you deserve everything you want in life and more",
  "you are so strong and such a light in this world",
  "the world is a better place bc you're here <3",
  "ur a baddieeeeeeeeeee",
  "you are capable of anything and everything you want to do",
  "you are magical, and I truly mean that! always keep shining",
  "breathe in. breathe out. you're doing great <3",
  "you are a force of nature, nothing can stop you",
  "you deserve rest",
  "drink water n stay hydrated ily",
  "you're so funny omg lolololololol :)",
  "keep fighting the good fight, you're doing so well"
];

// Personalized affirmations for specific people
export const PERSONALIZED_AFFIRMATIONS = {
  keerti: [
    "DOES THIS CUSTOM ONE SHOW UP TOO BESTIE LMAO all of these are unique and hand typed",
    "bestie you're truly THE blueprint. stay fierce",
    "you're a role model for not only all the AGPs but all the HSTS dolls",
    "your presence radiates through every room you walk in",
    "never forget the impact you make on SO many lives, literally every day",
    "you're a wizard bestie (this is a harry potter reference LOL, yer a wizard harry)",
    "when the days get hard, I'm always a call away. truly always here for you",
    "bestie, you have went through so much. if you can get through 2023, 2024 (ugh fall 2024) and 2025, you can get through anything <3",
  ],
  sneha: [
    "can't believe you built this app loser",
  ],
  gurnit: [
    "your presence keeps me going",
    "your joy and energy in every space keeps me alive",
    "love you 3000",
    "okay korean baddieeeee",
    "your dance skills are AMAZING???!!! like you're so talented!!!",
    "love you from last life",
  ],
    shruthi: [
    "your music fills my soul (and the souls of so many other ppl)",
    "you're literally the most beautiful fierce divaaaaaa"
  ],
  amorah: [
    "I know things have been tough lately, but I'm always rooting for you and I'm forever inspired by you",
    "I'll be in your life as long as you'll have me bestie. Love you always, keep shining!",
  ],
};